// Utility to derive MAPP-style properties from a product object.
/**
 * Derive mapped properties from a product object.
 * Input shape (example):
 * {
 *   category: { id: string, name: string },
 *   personas: [{ id: string, name: string }, ...],
 *   subjects: [{ id: string, name: string, parentId: string|null }, ...]
 * }
 * Output shape:
 * {
 *   category: 'Category Name',
 *   persona1: 'First Persona',
 *   persona2: 'Second Persona', // ... personaN for all personas
 *   secondarySubject: 'Child Subject Name'
 * }
 */
function getMappProperties(product) {
  if (!product || typeof product !== 'object') return {};

  const mappedProperties = {};

  // Category name
  let category = '';
  if (product.category && typeof product.category === 'object') {
    if (typeof product.category.name === 'string') {
      category = product.category.name;
    }
  }
  mappedProperties.category = category;

  // Personas -> persona1..personaN
  if (Array.isArray(product.personas)) {
    product.personas.forEach((persona, index) => {
      if (!persona || typeof persona.name !== 'string') return;
      const trimmedName = persona.name.trim();
      if (!trimmedName) return; // Skip adding a key if name is falsy/empty after trim

      const personaKey = `persona${index + 1}`;
      mappedProperties[personaKey] = trimmedName;
    });
  }

  // Secondary subject: choose first subject that has a parentId (i.e. a child subject)
  if (Array.isArray(product.subjects)) {
    let secondarySubject = '';
    const { id: parentId } = product.subjects.find(subject => subject && !subject.parentId) || {};
    const firstChildSubject = product.subjects.find(
      subject => subject && subject.parentId === parentId
    );
    if (firstChildSubject && typeof firstChildSubject.name === 'string') {
      secondarySubject = firstChildSubject.name;
    }
    mappedProperties.secondarySubject = secondarySubject;
  }

  return mappedProperties;
}

export default getMappProperties;
